module.exports = __webpack_public_path__ + "static/media/carousel_two_medium_720x480.43db020d.jpg";